/**
* 顶部个人中心组件
*/
<template>
  <div class="TPersonalNav">
    <div class="TPNleft">
      <div class="warpper">您好！欢迎光临北矿检测技术股份有限公司</div>
    </div>
    <div class="TPNright">
      <div class="personalText bold" @click="handleLogin">
        {{ status === 0 ? '登录': '退出登录'}}
      </div>
      <div class="personalText bold" @click="routLinkTo('/userCenter')">
        个人中心
      </div>
      <div class="personalText bold" @click="routLinkTo('/myOrder')">
        委托单管理
      </div>
      <div class="personalText bold" @click="routLinkTo('/cart/shoppingCart')">
        填写委托单
        <Badge class="zxbadge" :num="cartNum" :size="'regular'"/>
      </div>
    </div>
  </div>
</template>

<script>
// components
import Badge from '@/components/common/Badge'
import { mapGetters, mapMutations } from 'vuex'
import { getToken, removeToken } from '@/axios/cookies.js'
import { getUserInfo } from '@/api/login.js'
import { cartCount } from '@/api/cart.js'
export default {
components: { Badge },
  name: 'TopPersonalNav',
  data () {
    return {
      arr: {
        'right': [{
          'des': '委托单管理',
          'route': '/myOrder',
          'notice': 0
        }]
      },
      status: 1,
      // 首次登录修改信息
      firstLoginVisible: false,
      firstLoginForm: {
        username: '',
        nickname: '',
        password: '',
        passwordAgain: '',
        phone: '',
        email: ''
      },
    }
  },
  computed: {
    ...mapGetters([
      'cartNum', // 购物车商品数量
      'userInfo',  // 用户信息
    ])
  },
  watch: {
    'userInfo.username': {
      handler() {
        // 登录成功后更改登录状态
        this.isLogin();
      },
    },
  },
  created () {
    this.isLogin();
    this.setStateVariable();
  },
  methods: {
    ...mapMutations({
      setTargetRouter: 'SET_TARGETROUTE', // 保存目标路径
      setUserInfo: 'SET_USERINFO', // 修改用户信息
      setFirstLoginInfo: 'SET_FIRSTLOGININFO', // 记录首次登录填写信息
      setCartNum: 'SET_CARTNUM' // 修改购物车商品数量
    }),
    routLinkTo (val) {
      if (!val || val === this.$route.path) return;
      this.$router.push(val);
    },
    handleLogin() {
      console.log('---TopPersonalNav handleLogin---');
      this.isLogin();
      if (this.status) {  // 1已登陆，则进行退出登录操作
        this.$confirm('是否确认退出登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.handelLogout();
        }).catch(() => {});
      } else {  // 0未登录，则进行登陆操作
        this.$store.commit('setLoginVisible', true);
        // 暂不使用_从首页登录后自动跳转到委托单管理页面
        // if(this.$route.path === '/indexpage/index')
        //   this.$store.commit('setTargetRoute', {path: '/myOrder'});
      }
    },
    // 退出登录
    handelLogout() {
      // 移除token
      removeToken();
      // 清空vuex
      this.$store.commit('reset');
      // 改变“登录/退出登录”文字，移除localStorage中对是否为强口令密码的记录
      this.isLogin();
      // 路径返回首页
      // this.routLinkTo('/indexpage/index');
      this.routLinkTo('/indexpage/productlist');
      // 提示退出成功
      this.$message.success('退出成功');
    },
    isLogin () {
      let token = getToken();
      // 0未登录 1已登陆
      this.status = !token ? 0 : 1;
      if(!this.status) {  // 未登录
        // 移除localStorage中对是否为强口令密码的记录
        localStorage.removeItem('isStrongPwd');
      }
    },
    // 根据登录情况配置相应的状态信息
    setStateVariable() {
      if(this.status) {
        // 若为已登录，则请求购物车数量及用户信息
        this.getUserInfo();
        this.getCartNum();
      } else {
        // 若为未登录，购物车数量及用户信息制空
        this.$store.commit('setLoginVisible', false);
        this.setUserInfo({});
        this.$store.commit('setFirstLoginVisible', false);
        this.setFirstLoginInfo({});
        this.setCartNum(0);
      }
    },
    // 获取用户信息
    async getUserInfo () {
      let res = await getUserInfo();
      if (res.status === 200) {
        this.$store.commit('setLoginVisible', false);
        this.setUserInfo(res.data);
        if(this.status) {  // 已登录
          // 首次登录判断，false为未填写个人信息，true为填写过个人信息
          const completeInfo = res.data.additional.completeInfo;
          // 登录密码是否为弱口令，获取localStorage中存储的字符串
          const storeValue = localStorage.getItem('isStrongPwd');
          // 若存在，读取字符串转换为boolean；若不存在，配置默认值为true
          const isStrongPwd = storeValue !== null ? JSON.parse(storeValue) : true;
          // 登陆状态下，首次登录 or 弱口令 -> 进入个人信息完善页面
          if(!completeInfo || !isStrongPwd) {
            this.$store.commit('setFirstLoginVisible', true);
            this.setFirstLoginInfo({
              username: res.data.username,
              nickname: res.data.nickname,
              phone: res.data.phone,
              email: res.data.additional.email,
              taxId: res.data.additional.taxId,
              address: res.data.additional.address,
              bank: res.data.additional.bank,
              bankAccount: res.data.additional.bankAccount,
              password: '',
              passwordAgain: '',
              completeInfo, isStrongPwd
            });
          }
        }
      }
    },
    // 获取购物车商品数量
    async getCartNum () {
      let res = await cartCount();
      if (res.status === 200) {
        this.setCartNum(res.data.count);
      } else {
        this.$message.warning(res.msg);
      }
    },
  }
}
</script>

<style lang="scss">
.TPersonalNav{
  max-width: 1440px;
  min-width: 1170px;
  margin: auto;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  background-color: #F6F6F8;
  div{
    display: inline-block;
  }
  .TPNleft{
    margin-left: 135px;
    line-height: 40px;
  }
  .TPNright{
    float: right;
    margin-right: 135px;
    cursor: pointer;
    .zxbadge{
      display: inline-block;
      height: 20px;
      position: relative;
      left: -5px;
    }
    .personalText{
      margin-right: 15px;
      .wtd-icon{
        height: 18px;
        width: 18px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/TopPersonalNav2.vue